import React from 'react';

const styles = {
container: {
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    padding: '20px',
    marginTop: '20px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
},
heading: {
    color: '#2c3e50',
    fontSize: '1.8em',
    marginBottom: '15px'
},
text: {
    color: '#34495e',
    fontSize: '1.1em',
    lineHeight: '1.5'
}
};

const WelcomeMessage = () => {
return (
    <div style={styles.container}>
    <h2 style={styles.heading}>Hello, Developer!</h2>
    <p style={styles.text}>
        We're excited to have you here. This is your new React on Rails application.
        Feel free to explore and start building something amazing!
    </p>
    </div>
);
};

export default WelcomeMessage;

